import {
    EventListDto,
    TerminalSettingDto,
} from "./../../shared/service-proxies/service-proxies";
import {
    Component,
    Injector,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CorreiosService } from "@app/shared/common/correios/correios.service";
import { EmailsComponent } from "@app/shared/common/emails/emails.component";
import { PhonesComponent } from "@app/shared/common/phones/phones.component";
import { CartHelperService } from "@app/store/cart/cart-helper-service";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppPhoneType, AppUserAddressDtoType } from "@shared/AppEnums";
import { AppComponentBase } from "@shared/common/app-component-base";
import { UrlHelper } from "@shared/helpers/UrlHelper";
import {
    CategoryServiceProxy,
    CouponsServiceProxy,
    EventsServiceProxy,
    MemberCategoryEditDto,
    NoteDto,
    RegistrationsServiceProxy,
    RegistrationUserEditDto,
    RegistrationUserMemberEditDto,
    SessionServiceProxy,
    UpdateUserSignInTokenOutput,
    UserAddressDto,
    UserEmailDto,
    UserLoginInfoDto,
    UserPhoneDto,
    UserSelectListDto,
    UserServiceProxy,
} from "@shared/service-proxies/service-proxies";
import { FileDownloadService } from "@shared/utils/file-download.service";
import { AbpSessionService } from "abp-ng2-module/src/session/abp-session.service";
import { LoginService } from "account/login/login.service";
import * as moment from "moment";
import { finalize } from "rxjs/operators";
import { TerminalSettingsService } from "congress/shared/layout/terminal/terminal-settings.service";

@Component({
    selector: "app-begin",
    templateUrl: "./begin.component.html",
    styleUrls: [
        "./begin.component.css",
        "../shared/common/styles/congress.css",
    ],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
})
export class BeginComponent extends AppComponentBase implements OnInit {
    @ViewChild("emails") emails: EmailsComponent;
    @ViewChild("phones") phones: PhonesComponent;

    saving = false;
    searchUser = undefined;
    approvedRegistration = undefined;
    congress: EventListDto = undefined;

    newUser: RegistrationUserEditDto;
    users = [];
    userToRegistration = undefined;

    appUserAddressDtoType = AppUserAddressDtoType;
    emailDto = UserEmailDto;
    phoneDto = UserPhoneDto;

    note: NoteDto;

    currentDate = moment(moment().format("YYYY-MM-DD"));

    userId: number;

    countries: any[] = CorreiosService.loadCountries();
    brazilStates = CorreiosService.loadBrazilStates();
    citiesFromState = [];

    categories = [];
    eventId = undefined;

    memberCategory = undefined;
    categoryLevelId = undefined;

    userLogged = this.appSession.user;
    userLoaded = false;

    _settings: TerminalSettingDto = undefined;

    constructor(
        injector: Injector,
        private route: ActivatedRoute,
        private _registrationsService: RegistrationsServiceProxy,
        private _correiosService: CorreiosService,
        private _router: Router,
        private _userService: UserServiceProxy,
        private _categoryService: CategoryServiceProxy,
        private _cartHelperService: CartHelperService,
        public _loginService: LoginService,
        private _activatedRoute: ActivatedRoute,
        private _sessionService: AbpSessionService,
        private _terminalServiceSettings: TerminalSettingsService,
        private _sessionAppService: SessionServiceProxy
    ) {
        super(injector);
    }

    ngOnInit() {
        this._settings = this._terminalServiceSettings.getSettings();
        if (this._settings) {
            this.congress = this._settings.eventsList[0];
        }

        this.route.queryParams.subscribe((params: Params) => {
            this.eventId = +params["eventId"];
        });

        this.userLogged = this.appSession.user;

        if (this.userLogged) this.redirectByTerminalSettings();

        this.initLogin();

        this.loadCategories();
    }

    //Verify login on init
    initLogin() {
        this._loginService.authenticateModel.userNameOrEmailAddress =
            this._activatedRoute.snapshot.queryParams["id"];
        if (
            this._sessionService.userId > 0 &&
            UrlHelper.getReturnUrl() &&
            UrlHelper.getSingleSignIn()
        ) {
            this._sessionAppService
                .updateUserSignInToken()
                .subscribe((result: UpdateUserSignInTokenOutput) => {
                    const initialReturnUrl = UrlHelper.getReturnUrl();
                    const returnUrl =
                        initialReturnUrl +
                        (initialReturnUrl.indexOf("?") >= 0 ? "&" : "?") +
                        "accessToken=" +
                        result.signInToken +
                        "&userId=" +
                        result.encodedUserId +
                        "&tenantId=" +
                        result.encodedTenantId;

                    location.href = returnUrl;
                });
        }
    }

    //Login only CPF
    login(): void {
        this.saving = true;
        this._loginService.authenticateModel.userNameOrEmailAddress =
            this.searchUser;
        this._loginService.authenticateModel.password = "congress2023"; //Senha será resetada no backend: 6 primeiros digitos do CPF
        this._loginService.authenticateModel.refererUrl = window.location.href;
        this._loginService.authenticate(() => {
            this.saving = false;
            this.userLogged = this.appSession.user;
            this._cartHelperService.updateUserCart(
                this.userToRegistration,
                false
            );
            localStorage.setItem("showRegistrationMessage", 'true');
            this.redirectByTerminalSettings();
        });
    }

    redirectByTerminalSettings() {
        if (this._terminalServiceSettings.allowOnlyCredential())
            this._router.navigate(["congresso/credencial"]);
        else if (this._terminalServiceSettings.allowOnlyRegistrations())
            this._router.navigate(["congresso/eventos"]);
        else if (this._terminalServiceSettings.allowOnlyAnnuity())
            this._router.navigate(["congresso/anuidade"]);
    }

    //Load member categories
    loadCategories() {
        this._categoryService
            .getForSelect("", undefined, true, false)
            .subscribe((result) => {
                this.categories = result.items;
            });
    }

    //Check user by search
    checkSearchUser() {
        if (
            this.searchUser &&
            this.searchUser.length == 11 &&
            !isNaN(Number(this.searchUser))
        ) {
            this.block(".m-portlet");

            let search = { query: this.searchUser };
            this.filterUsers(search);
        }
    }

    // Get Users
    filterUsers(event): void {
        this.saving = true;

        this._userService
            .getUsersForSelect(event.query, undefined, 20, 0)
            .subscribe((result) => {
                this.unBlock(".m-portlet");
                this.saving = false;

                if (
                    result.items.length == 0 &&
                    event.query.length == 11 &&
                    !isNaN(Number(event.query))
                ) {
                    let newUser = new UserSelectListDto();
                    newUser.name = this.l("New User");
                    newUser.userName = event.query;
                    this.users = [];
                    this.users.push(newUser);
                } else {
                    this.users = result.items;
                }

                this.userToRegistration = new UserSelectListDto();
                this.userToRegistration.id = this.users[0].id;
                this.userToRegistration.name = this.users[0].name;
                this.userToRegistration.userName = this.users[0].userName;
                this.onSelectUser();
                setTimeout(() => {
                    $("[name='emailAddressUser']").focus();
                }, 0);
            });
    }

    //Select User
    onSelectUser(): void {
        this.memberCategory = undefined;
        this.approvedRegistration = false;

        if (this.userToRegistration.id) {
            this.userId = this.userToRegistration.id;

            this.loadUserForSubscription(true);
        } else {
            this.newUser = new RegistrationUserEditDto();
            this.newUser.userName = this.userToRegistration.userName;
            this.newUser.emails = undefined;
            this.newUser.phones = [];
            this.newUser.address = new UserAddressDto();

            setTimeout(() => {
                this.adjustUser();
            }, 0);
        }
    }

    //load user
    loadUserForSubscription(onlyCheckApproved?: boolean): void {
        this.saving = true;
        this._registrationsService
            .getUserForRegistration(this.userId, undefined, undefined)
            .subscribe((result) => {
                this.approvedRegistration = result.hasRegistration;
                this.userToRegistration = result;

                //TODO: Carregar usuário logado
                this.login();

                if (onlyCheckApproved == undefined) {
                    this.newUser = new RegistrationUserEditDto();
                    this.adjustUser();
                    this.loadCitiesFromState();
                }
            });
    }

    //Adjust user data
    adjustUser() {
        if (this.newUser.phones.length == 0) {
            let phone = new UserPhoneDto();
            phone.type = AppPhoneType.Mobile;
            phone.ddi = "55";
            this.newUser.phones.push(phone);
        }

        if (!this.newUser.address.id) {
            this.newUser.address = new UserAddressDto();
            this.newUser.address.countryName = "BRASIL";
            this.newUser.address.type = AppUserAddressDtoType.Home;
            this.newUser.address.isMailing = true;
        }

        if (this.newUser.emails == undefined) {
            this.newUser.emails = [];
        }
    }

    //Search address by zipcode
    searchZipCode() {
        let zipCode = this.newUser.address.zipCode;

        if (zipCode && zipCode.length >= 8) {
            this._correiosService.searchByPostalCode(zipCode).then((result) => {
                let data = result[0];

                if (!!data) {
                    this.newUser.address.city = data.Municipio.toUpperCase();
                    this.newUser.address.complement =
                        data.Complemento.toUpperCase();
                    this.newUser.address.district = data.Bairro.toUpperCase();
                    this.newUser.address.logradour =
                        data.Logradouro.toUpperCase();
                    this.newUser.address.stateAbbreviation =
                        data.Estado.toUpperCase();
                    this.newUser.address.stateName = data.Estado.toUpperCase();
                    this.newUser.address.countryName = "BRASIL";
                }

                this.loadCities();
            });
        }
    }

    //load cities
    loadCities() {
        let stateAbbreviation = this.newUser.address.stateAbbreviation;

        if (this.isBrasil()) {
            this._correiosService
                .loadCities(stateAbbreviation)
                .then((cities) => {
                    this.citiesFromState = cities;
                    this.setValueStateName();
                });
        } else this.newUser.address.stateName = stateAbbreviation;
    }

    //clear state and city address
    clearStateAndCity() {
        this.newUser.address.stateName = "";
        this.newUser.address.stateAbbreviation = "";
        this.newUser.address.city = "";
        this.newUser.address.zipCode = "";
    }

    //set state name
    setValueStateName() {
        this.brazilStates.forEach((state) => {
            if (state.abbreviation == this.newUser.address.stateAbbreviation) {
                this.newUser.address.stateName = state.name;
            }
        });
    }

    // load cities Address
    loadCitiesFromState() {
        if (this.isBrasil()) {
            this._correiosService
                .loadCities(this.newUser.address.stateAbbreviation)
                .then((cities) => {
                    this.citiesFromState = cities;
                });
        }
    }

    //check Brazil
    isBrasil(): boolean {
        return this.newUser.address.countryName == "BRASIL";
    }

    //Valid email
    formEmailsIsInvalid(): boolean {
        return this.emails && this.emails.emailsForm.invalid;
    }

    //valid phone
    formPhonesIsInvalid(): boolean {
        return this.phones && this.phones.phonesForm.invalid;
    }

    //Valid all forms
    formIsValid(formValid: boolean): boolean {
        return (
            formValid &&
            !this.formPhonesIsInvalid() &&
            !this.formEmailsIsInvalid()
        );
    }

    //Save new User
    saveUser() {
        this.newUser.member = new RegistrationUserMemberEditDto();
        this.newUser.member.categories = [];

        let category = new MemberCategoryEditDto();
        category.categoryId = this.memberCategory.id;
        category.categoryLevelId = this.categoryLevelId;

        this.newUser.member.categories.push(category);

        this.saving = true;
        this._registrationsService
            .createUserForRegistration(this.newUser)
            .finally(() => {
                this.saving = false;
            })
            .subscribe((result) => {
                if (!result) {
                    this.message.warn(this.l("Registro não encontrado"));
                } else {
                    this.notify.info(this.l("SavedSuccessfully"));

                    //TODO: Carregar usuário logado
                    this.login();
                }
            });
    }

    //clear category level
    clearCategoryLevelId(): void {
        this.categoryLevelId = undefined;

        if (this.memberCategory.levels.length > 0) {
            setTimeout(() => {
                this.categoryLevelId = this.memberCategory.levels[0].id;
            }, 0);
        }
    }

    //cancel new user registration
    cancel() {
        this.newUser = undefined;
        this.searchUser = undefined;
    }

    //go to page
    gotoUrl(url: string) {
        setTimeout(() => {
            this._router.navigate([url]);
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./src/congress/begin/begin.component.ts